document.addEventListener('DOMContentLoaded', function () {
    function showPriceAndForm() {
        document.querySelectorAll('.price__container').forEach(container => {
            container.classList.remove('hidden');
        });
        const formElement = document.querySelector('product-form.product-form');
        const disabledButton = formElement?.querySelector('button[disabled]');
        if (!disabledButton) {
            formElement?.classList.remove('hidden');
            formElement?.classList.remove('js-hidden');
            document.querySelector('.quote-request__button')?.classList.add('hidden');
        }
    }

    fetch(
        'https://api.ipgeolocation.io/ipgeo?apiKey=53d96275df44451bb41dad25faf2391b&fields=country_code2,country_code3,country_name,state_prov'
    )
        .then(response => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Wrong API KEY');
        })
        .then(response => {
            const userLocation = [
                response.country_code2,
                response.country_code3,
                response.country_name,
                response.state_prov
            ].map(loc => loc.toLowerCase());

            if (requiredRegions.length > 0) {
                requiredRegions.forEach(region => {
                    let realRegions = [region.toLowerCase()];
                    if (region.includes(',') && ['usa', 'us', 'united states'].includes(region.split(',')[0].toLowerCase())) {
                        realRegions = region.split(',').slice(1).map(r => r.toLowerCase());
                    }
                    
                    realRegions.forEach(realRegion => {
                        if (userLocation.includes(realRegion)) {
                            showPriceAndForm();
                        }
                    });
                });
            } else {
                let shouldShow = true;
                forbiddenRegions.forEach(region => {
                    if (userLocation.includes(region.toLowerCase())) {
                        shouldShow = false;
                    }
                });
                
                if (shouldShow) {
                    showPriceAndForm();
                }
            }
        })
        .catch(error => {
            console.log(error);
        });
});
